export default __webpack_public_path__ + "static/media/instagram.421e1e95.svg";